// extracted by mini-css-extract-plugin
export default {"root":"Page__root___taiIj","title":"Page__title___wiO2t","content":"Page__content___Y0RT3","row":"Page__row___OwHBt"};